// import { G } from '@/_common';

export const main_stores = {
    api: {
    },
    getters: {
    },
}
